import {Controller} from "stimulus"
import {decodeDirectionsPath} from "controllers/google-maps-directions"
import GoogleMapsLoader from "shared/google-maps-loader"

export default class GoogleMapsController extends Controller {
  async connect() {
    const element = this.element
    const mapOptions = {
      center: {
        lat: 0,
        lng: 0
      },
      zoom: 0
    }

    try {
      await GoogleMapsLoader.load(["geometry", "places"])
    } catch (error) {
      FlashMessage.errorResponse(error)

      return
    }

    const map = new google.maps.Map(element, mapOptions)

    if (this.data.get("directions")) {
      this.drawDirectionsOnMap(map)
    }
  }

  drawDirectionsOnMap(map) {
    const bounds = new google.maps.LatLngBounds()
    const directions = JSON.parse(this.data.get("directions"))
    const legs = directions.routes[0].legs
    const geometryEncoding = digg(google, "maps", "geometry", "encoding")
    const path = decodeDirectionsPath(legs, geometryEncoding)

    if (!geometryEncoding) {
      console.warn("Google Maps geometry library is not loaded - skipping the route path")
    }

    for (const pathElement of path) {
      bounds.extend(pathElement)
    }

    const markers = [{position: legs[0].start_location, title: legs[0].start_address}]

    for (const leg of legs) {
      markers.push({position: leg.end_location, title: leg.end_address})
    }

    // draw markers
    let i = 1

    for (const marker of markers) {
      // eslint-disable-next-line no-new
      new google.maps.Marker({
        label: `${i}`,
        map,
        position: marker.position,
        title: marker.title
      })
      i++
    }

    // eslint-disable-next-line no-new
    new google.maps.Polyline({
      map,
      path,
      strokeColor: "#DC143C",
      strokeWeight: 3
    })

    map.fitBounds(bounds)
  }
}
